import React, { ChangeEvent, FC, useState } from "react";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { CityInput } from "@/components/elements/CityInput";
import { Grid } from "@mui/material";
import { useFormContext, Path } from "react-hook-form";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { useLocationInfo } from "@/hooks/useLocationInfo";
import { convertFullWidthToHalfWidth } from "@/utils/pieces";
import { PLACEHOLDER_LOCATION_FIELD } from "@/features/company/constants/string";
import { convertNumberToZipCode } from "@/utils/input";

type TCompanyBranchProps = {
  index: number;
  readonly?: boolean;
};
export const CompanyBranchItem: FC<TCompanyBranchProps> = ({ readonly, index }) => {
  const methods = useFormContext<TCompanyForm>();
  const { control, setValue } = methods;

  const locationInfo = useLocationInfo({
    methods,
    names: {
      zipCode: `companyBranches.${index}.zipCode`,
      province: `companyBranches.${index}.prefecture`,
      municipality: `companyBranches.${index}.city`,
      address: `companyBranches.${index}.address`,
    },
  });

  const [isComposing, setIsComposing] = useState(false);

  const handleCompositionStart = () => setIsComposing(true);
  const handleCompositionEnd = (e: React.CompositionEvent<HTMLInputElement>) => {
    setIsComposing(false);
    onChangeZipCode(e as unknown as ChangeEvent<HTMLInputElement>);
  };

  const onChangeZipCode = (e: ChangeEvent<HTMLInputElement>) => {
    if (!isComposing) {
      let newValue = convertFullWidthToHalfWidth(e.target.value);
      newValue = convertNumberToZipCode(newValue);
      setValue(`companyBranches.${index}.zipCode`, newValue);
    }
  };

  const onChangePhone = (e: ChangeEvent<HTMLInputElement>) => {
    if (!isComposing) {
      const newValue = convertFullWidthToHalfWidth(e.target.value);
      setValue(`companyBranches.${index}.telNumber`, newValue, {
        shouldValidate: true,
      });
    }
  };

  const onChangeFax = (e: ChangeEvent<HTMLInputElement>) => {
    if (!isComposing) {
      const newValue = convertFullWidthToHalfWidth(e.target.value);
      setValue(`companyBranches.${index}.faxNumber`, newValue, {
        shouldValidate: true,
      });
    }
  };

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <FormField label="事業所名" control={control} name={`companyBranches.${index}.branchName`} required>
          <Input placeholder="入力してください" readonly={readonly} cleanWhitespace />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <FormField label="郵便番号" control={control} name={`companyBranches.${index}.zipCode`} isMessageNowrap>
          <Input
            placeholder={PLACEHOLDER_LOCATION_FIELD}
            readonly={readonly}
            onChange={onChangeZipCode}
            onCompositionStart={handleCompositionStart}
            onCompositionEnd={handleCompositionEnd}
          />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <FormField label="都道府県" control={control} name={`companyBranches.${index}.prefecture`}>
          <Input placeholder={PLACEHOLDER_LOCATION_FIELD} readonly />
        </FormField>
      </Grid>
      <Grid item xs={4}>
        <CityInput
          name={`companyBranches.${index}.city` as Path<TCompanyForm>}
          control={control}
          zipCodeFieldName={`companyBranches.${index}.zipCode` as Path<TCompanyForm>}
          locationInfo={locationInfo}
          label="市区町村"
        />
      </Grid>
      <Grid item xs={12}>
        <FormField label="町名丁目番地号等" control={control} name={`companyBranches.${index}.address`}>
          <Input placeholder={PLACEHOLDER_LOCATION_FIELD} readonly={readonly} />
        </FormField>
      </Grid>
      <Grid item xs={6}>
        <FormField label="事業所代表電話番号" control={control} name={`companyBranches.${index}.telNumber`}>
          <Input readonly={readonly} onChange={onChangePhone} onCompositionStart={handleCompositionStart} onCompositionEnd={handleCompositionEnd} />
        </FormField>
      </Grid>
      <Grid item xs={6}>
        <FormField label="FAX番号" control={control} name={`companyBranches.${index}.faxNumber`}>
          <Input readonly={readonly} onChange={onChangeFax} onCompositionStart={handleCompositionStart} onCompositionEnd={handleCompositionEnd} />
        </FormField>
      </Grid>
      <Grid item xs={12}>
        <FormField label="この事業所について" control={control} name={`companyBranches.${index}.branchDescription`}>
          <Input placeholder="入力してください" readonly={readonly} cleanWhitespace />
        </FormField>
      </Grid>
    </Grid>
  );
};
